import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { SYDLEClientID } from '../../shared/constants/one-constants';
import { Contract } from '../../shared/model/contract';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { CheckoutSuccessData } from 'src/app/shared/model/checkout-success-data';
import { CheckoutService } from 'src/app/shared/services/checkout.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { HttpService } from 'src/app/shared/services/http.service';
import { DialogData } from 'src/app/shared/model/dialog-data';
import { DialogAlertComponent } from 'src/app/shared/components/dialog-alert/dialog-alert.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { Api } from 'src/app/shared/enum/Api';

import { DtmService } from 'src/app/services/dtm.service';
import { Dtm, getDtm } from 'src/app/shared/enum/dtm';

enum PaymentMethod {
  PIX = 'PIX',
  CREDIT_CARD = 'CREDIT_CARD',
  BANK_BILLET = 'BANK_BILLET'
}

@Component({
    selector: 'pme-success',
    templateUrl: './success.component.html',
    styleUrls: ['./success.component.scss'],
    standalone: false
})
export class SuccessComponent implements OnInit, OnChanges {

  productFamily: string;
  productFamilyIdentifier: string;
  productName: string;
  productIdentifier: string;
  valuePerMonth: string;
  totalValue: string;
  productImg: string;
  installments: number;
  productValue: string;
  discountedValue: string;
  couponAmount: number;
  checkoutSuccessData: CheckoutSuccessData;
  getBalanceExpirationDate: any;
  paymentMethodEnum = PaymentMethod;
  paymentMethod: string;
  interval: any;
  isPixPaid: boolean = false;
  timeExpired: boolean = false;
  expirationTime: number;
  submitting: boolean;

  customer: any;
  businessId: string;
  userId: string;
  confirmationData: any;
  coupons: any;


  constructor(
    public sessionStorageService: SessionStorageService,
    private checkoutService: CheckoutService,
    private dtmService: DtmService,
    private snackBarService: SnackBarService,
    private httpService: HttpService,
    public dialog: MatDialog,
  ) {
    this.getBalanceExpirationDate = this.checkoutService.getBalanceExpirationDate(this.productFamilyIdentifier);
    this.checkoutSuccessData = this.checkoutService.getLocalStorageCheckoutSuccessData();
    this.paymentMethod = this.sessionStorageService.getCustomData('paymentMethod');
    this.sessionStorageService.setCustomData('disconnectedSaleStep', 'success');
    if (this.paymentMethod === PaymentMethod.PIX) this.sessionStorageService.setCustomData('disconnectedSaleStep', 'payment');

    console.log(this.sessionStorageService.getCustomData('paymentMethod'));

    this.expirationTime = this.expirationTime && this.expirationTime > 0 ? this.expirationTime : (new Date(this.checkoutSuccessData.pixData?.pixExpiryTime).getTime() - new Date().getTime()) / 1000;

    // Inicializando as variáveis que serão usadas em outros métodos
    this.customer = this.sessionStorageService.getCustomer();
    this.businessId = this.customer.provisioningParameter.businessId;
    this.userId = this.customer.provisioningParameter.userId;

    this.confirmationData = {
      orderId: this.checkoutSuccessData.contract.code,
      pagamento: this.checkoutSuccessData.contract.paymentMethod.identifier,
      orderEventId: this.checkoutSuccessData.creditCardData ?
        this.checkoutSuccessData.creditCardData.invoiceId : this.checkoutSuccessData.bankBilletData ?
          this.checkoutSuccessData.bankBilletData.invoiceId : this.checkoutSuccessData.pixData ?
            this.checkoutSuccessData.pixData.invoiceId : '',
      totalPrice: this.totalValue,
      amountPaid: this.totalValue,
      firstTime: this.checkoutSuccessData.contract.adobeAnalyticsData ? this.checkoutSuccessData.contract.adobeAnalyticsData.firstPurchase : null,
      orderType: this.checkoutSuccessData.contract.adobeAnalyticsData ? this.checkoutSuccessData.contract.adobeAnalyticsData.purchaseType : null,
      amountRemaining: this.checkoutSuccessData.contract.product.value ? this.checkoutSuccessData.contract.product.value - Number(this.totalValue) : 0,
      amountTotal: this.checkoutSuccessData.contract.product.value,
      coupon: this.checkoutSuccessData.getConcatenatedDiscounts(),
      mgmCoupon: this.checkoutSuccessData.contract.mgmCoupon,
      couponAmount: this.couponAmount,
      autoRecharge: this.checkoutSuccessData.contract.provisioningParameters.allowAutomaticRecharge === true,
      appliedCoupons: this.coupons,
      installments: this.checkoutSuccessData.contract.paymentMethod.identifier === 'CREDIT_CARD' ?
        this.checkoutSuccessData.contract.paymentMethod.paymentConditionIdentifier : null,
      purchaseStatus: this.checkoutSuccessData.contract.status,
      bonusAmount: this.checkoutSuccessData.bonusAmount || null,
      bonus: this.checkoutSuccessData.bonus || null,
      oneClick: this.checkoutSuccessData.oneClick || false,
      purchaseOrigin: this.checkoutSuccessData.purchaseOrigin || null
    };
    this.setProductData();
  }
  ngOnInit(): void {
    this.expirationTime = this.expirationTime && this.expirationTime > 0 ? this.expirationTime : (new Date(this.checkoutSuccessData.pixData?.pixExpiryTime).getTime() - new Date().getTime()) / 1000;
  }

  ngOnChanges(): void {
    this.expirationTime = this.expirationTime && this.expirationTime > 0 ? this.expirationTime : (new Date(this.checkoutSuccessData.pixData?.pixExpiryTime).getTime() - new Date().getTime()) / 1000;
  }

  setProductData() {
    let productData = JSON.parse(this.sessionStorageService.getCustomData('disconnectedSaleProduct'));
    let installmentData = this.getInstallmentData();
    let cartProductData = JSON.parse(this.sessionStorageService.getCustomData('cart'));
    this.productFamily = productData.classification;
    this.productFamilyIdentifier = productData.classificationIdentifier;
    this.productName = productData.productName;
    this.valuePerMonth = installmentData.installmentValue;
    this.totalValue = Number(cartProductData.totalValue).toFixed(2).replace('.', ',');
    this.productImg = productData.productImg;
    this.installments = installmentData.installment;
    this.productValue = Number(cartProductData.baseValue).toFixed(2).replace('.', ',');
    this.discountedValue = Number(cartProductData.discountedValue).toFixed(2).replace('.', ',');
    this.productIdentifier = this.sessionStorageService.getCustomData('productIdentifier');
    this.dtmService.userLoaded({
      userId: this.userId,
      businessId: this.businessId,
      clientId: SYDLEClientID
    });
    console.log(this.checkoutSuccessData);
    let product = this.checkoutSuccessData.contract.product;
    this.dtmService.pageLoaded(Dtm.SucessoDeslogado, true, getDtm(Dtm.SucessoDeslogado, this.productFamilyIdentifier));
    this.dtmService.productsLoaded([{
      identifier: this.productIdentifier,
      classificationName: this.productName,
      quantity: 1,
      totalValue: this.totalValue.replace(',','.'),
      merchandising: product
    },]);

    this.dtmService.checkoutSuccess(this.confirmationData);
    this.dtmService.customLoaded(['Purchase', 'Transaction'], 'Sydle-compra-deslogada');
    this.dtmService.sendPurchaseEvent();
  }

  getInstallmentData() {
    let checkoutSuccessData = this.checkoutService.getLocalStorageCheckoutSuccessData();
    let installments: number = checkoutSuccessData.contract.paymentMethod?.paymentConditionIdentifier && checkoutSuccessData.contract.paymentMethod.identifier === "CREDIT_CARD"? Number(
      checkoutSuccessData.contract.paymentMethod?.paymentConditionIdentifier.includes("creditCard") ?
      checkoutSuccessData.contract.paymentMethod?.paymentConditionIdentifier.split("creditCard")[1].split("X")[0]:
      checkoutSuccessData.contract.paymentMethod?.paymentConditionIdentifier.split("CreditCard")[1].split("X")[0]
    ) : 1;


    let installmentValue;

    switch (checkoutSuccessData.contract.paymentMethod.identifier) {
      case 'CREDIT_CARD':
        installmentValue = Number(checkoutSuccessData.creditCardData.totalValue) / installments;
        break;
      case 'BANK_BILLET':
        installmentValue = Number(checkoutSuccessData.bankBilletData.totalValue);
        break;
      case 'PIX':
        installmentValue = Number(checkoutSuccessData.pixData.totalValue);
        break;
      default:
        installmentValue = 0;
    }
    return {
      installment: installments,
      installmentValue: installmentValue.toFixed(2).replace('.', ',')
    };
  }


  openBankBilletOnNewTab(url) {
    window.open(url, '_blank');
  }

  copyContent() {
    navigator.clipboard.writeText(this.checkoutSuccessData.bankBilletData.barcode);
    this.snackBarService.openSnackBar('Código copiado');
  }

  checkPurchaseIntegrationStatus(contractCode: string): Promise<string> {
    return lastValueFrom(this.httpService.post('eCommercePME/eCommerceAPI/checkPurchaseIntegrationStatus', Api.One_Portal,
      {
        'contractCode': contractCode
      }))
      .then(result => {
        return result.integrationStatus;
      });
  }
  openErrorIntegrationDialog(productIdentifier) {
    const data = DialogData.fromPreset("processingPurchase");
    const errorMessage = data.errorMessage;

    this.dialog.open(DialogAlertComponent, {
      disableClose: false,
      panelClass: 'pme-dialog-alert-panel',
      autoFocus: false,
      data: data
    });
  }

  hasPixPaid(event) {
    this.dtmService.userLoaded({
      userId: this.userId,
      businessId: this.businessId,
      clientId: SYDLEClientID
    });
    let product = this.checkoutSuccessData.contract.product;
    this.dtmService.pageLoaded(Dtm.PagamentoReconhecidoDeslogado, true, getDtm(Dtm.PagamentoReconhecidoDeslogado, this.productFamilyIdentifier));
    this.dtmService.productsLoaded([{
      identifier: this.productIdentifier,
      classificationName: this.productName,
      quantity: 1,
      totalValue: this.totalValue.replace(',','.'),
      merchandising: product
    },]);
    this.dtmService.checkoutSuccess(this.confirmationData);
    this.dtmService.customLoaded(['Purchase', 'Transaction'], 'Sydle-compra-deslogada')
    this.dtmService.sendPixConfirmation();

    this.isPixPaid = true;
    this.sessionStorageService.setCustomData('disconnectedSaleStep', 'success');
  }

  redirectSuccess() {
    let validationData = JSON.parse(this.sessionStorageService.getCustomData('validationData'));
    document.location.href = environment.redirect_disconnect_sale + `cadastro/criar-senha?user=${validationData.email}`;
  }

}
